import { useQuery } from '@apollo/client/react';
import { useRouter } from 'expo-router';
import { useCallback } from 'react';
import { FAB, useTheme } from 'react-native-paper';

import { MeDocument } from '@/generated/usermobile-bff/graphql';
import { useAiTranscriptionConsentDialog } from '@/hooks';
import { useVoiceRecordingStore } from '@/stores';

export const StandaloneRecordingFab = () => {
  const theme = useTheme();
  const router = useRouter();
  const { handleAccept, consentDialog } = useAiTranscriptionConsentDialog();
  const recording = useVoiceRecordingStore((state) => state.recording);
  const requestMicrophonePermission = useVoiceRecordingStore(
    (state) => state.requestMicrophonePermission,
  );
  const { data } = useQuery(MeDocument);

  const isRecording = recording.status !== 'idle';

  const startRecordingFlow = useCallback(async () => {
    if (!data?.me) {
      return;
    }

    const granted = await requestMicrophonePermission();
    if (!granted) {
      return;
    }

    router.push({
      pathname: '/recording',
      params: { userId: data.me.id, accountId: data.me.accountId },
    });
  }, [data, router, requestMicrophonePermission]);

  const handlePress = useCallback(() => {
    handleAccept(() => {
      void startRecordingFlow();
    });
  }, [handleAccept, startRecordingFlow]);

  if (isRecording) {
    return null;
  }

  return (
    <>
      {consentDialog}
      <FAB
        icon="microphone"
        style={{
          position: 'absolute',
          margin: 16,
          right: 0,
          bottom: 0,
          backgroundColor: theme.colors.primary,
        }}
        color={theme.colors.onPrimary}
        onPress={handlePress}
        testID="standalone-recording-fab"
      />
    </>
  );
};
